import { selector } from 'recoil'
import projectStagesAtom from './projectStages.atom'
import { ProjectStagesMap } from './projectTypes.types'

const projectStagesMap = selector({
  key: 'selectors/project-stages-map',
  get: ({ get }): ProjectStagesMap=> {
    const projectStagesState = get(projectStagesAtom)

    return projectStagesState.items.reduce((acc, val) => ({ ...acc, [val.id]: val}), {})
  },
})

const projectStagesSelectors = { projectStagesMap }
export default projectStagesSelectors
